/**
 * @generated SignedSource<<abf810441fc8b9876362102410063266>>
 * @relayHash 8f585f7b208b0e6773f1edb0e78caac6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f585f7b208b0e6773f1edb0e78caac6

import type { ConcreteRequest } from 'relay-runtime';
export type IssueFieldSingleSelectOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type SetIssueFieldValueInput = {
  clientMutationId?: string | null | undefined;
  issueFields: ReadonlyArray<IssueFieldCreateOrUpdateInput>;
  issueId: string;
};
export type IssueFieldCreateOrUpdateInput = {
  dateValue?: string | null | undefined;
  delete?: boolean | null | undefined;
  fieldId: string;
  numberValue?: number | null | undefined;
  singleSelectOptionId?: string | null | undefined;
  textValue?: string | null | undefined;
};
export type setIssueFieldValueMutation$variables = {
  input: SetIssueFieldValueInput;
};
export type setIssueFieldValueMutation$data = {
  readonly setIssueFieldValue: {
    readonly issue: {
      readonly id: string;
    } | null | undefined;
    readonly issueFieldValues: ReadonlyArray<{
      readonly color?: IssueFieldSingleSelectOptionColor;
      readonly description?: string | null | undefined;
      readonly id?: string;
      readonly name?: string;
      readonly value?: string;
    }> | null | undefined;
  } | null | undefined;
};
export type setIssueFieldValueMutation = {
  response: setIssueFieldValueMutation$data;
  variables: setIssueFieldValueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "IssueFieldTextValue",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "IssueFieldSingleSelectValue",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "IssueFieldDateValue",
  "abstractKey": null
},
v7 = [
  (v2/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setIssueFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetIssueFieldValuePayload",
        "kind": "LinkedField",
        "name": "setIssueFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "issueFieldValues",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setIssueFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetIssueFieldValuePayload",
        "kind": "LinkedField",
        "name": "setIssueFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "issueFieldValues",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v7/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "8f585f7b208b0e6773f1edb0e78caac6",
    "metadata": {},
    "name": "setIssueFieldValueMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cf2ea6b4c8e0c41d3b19f841a3da2404";

export default node;
